module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', {
    attrs: {
      "for": "new_type"
    }
  }, [_vm._v("Ny aktivitetsstyp:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.new_type.name),
      expression: "new_type.name"
    }],
    staticClass: "mdl-textfield__input",
    attrs: {
      "id": "new_type",
      "type": "text"
    },
    domProps: {
      "value": (_vm.new_type.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.new_type, "name", $event.target.value)
      }
    }
  }), _c('button', {
    staticClass: "mdl-button mdl-button--icon",
    on: {
      "click": function($event) {
        _vm.addType()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])]), _c('ul', {
    directives: [{
      name: "sortable",
      rawName: "v-sortable.li",
      value: (_vm.reorderTypes),
      expression: "reorderTypes",
      modifiers: {
        "li": true
      }
    }]
  }, _vm._l((_vm.activity_types.getEmbeds('activity_type')), function(type, idx) {
    return _c('li', {
      key: idx,
      staticClass: "mdl-list__item",
      attrs: {
        "id": type.uid,
        "data-order": idx
      }
    }, [_vm._m(0, true, false), (_vm.edit_uid != type.uid) ? _c('span', {
      staticClass: "mdl-textfield__input",
      on: {
        "click": function($event) {
          _vm.doEdit(type)
        }
      }
    }, [_vm._v(_vm._s(type.name))]) : _vm._e(), (_vm.edit_uid == type.uid) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.edit_type.name),
        expression: "edit_type.name"
      }],
      staticClass: "mdl-textfield__input",
      attrs: {
        "maxlength": "36",
        "type": "text"
      },
      domProps: {
        "value": (_vm.edit_type.name)
      },
      on: {
        "change": function($event) {
          _vm.updateType(_vm.edit_type)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.edit_type, "name", $event.target.value)
        }
      }
    }) : _vm._e(), _c('button', {
      staticClass: "mdl-button mdl-button--icon",
      on: {
        "click": function($event) {
          _vm.deleteType(type)
        }
      }
    }, [_c('i', {
      staticClass: "material-icons"
    }, [_vm._v("delete")])])])
  })), _c('v-dialog-confirm', {
    attrs: {
      "id": "confirm",
      "message": _vm.show.message
    },
    on: {
      "ok": function($event) {
        _vm.show.action()
      },
      "cancel": _vm.cancel
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-button--icon my-handle"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("swap_vert")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2716672f","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/administration/Activities.vue
// module id = 509
// module chunks = 1